import { makeServiceRequest } from '../ServiceRequest';
import RequestOptions from '../RequestOptions';
import GetItemJsonRequest from '../contract/GetItemJsonRequest';
import GetItemJsonResponse from '../contract/GetItemJsonResponse';
import getItemJsonRequest from '../factory/getItemJsonRequest';

export default function getItemOperation(
    req: GetItemJsonRequest,
    options?: RequestOptions
): Promise<GetItemJsonResponse> {
    if (req !== undefined && !req['__type']) {
        req = getItemJsonRequest(req);
    }

    return makeServiceRequest<GetItemJsonResponse>('GetItem', req, options);
}
